"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_typed_1 = __importDefault(require("react-typed"));
var RotatingLinks = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, strings = _a.strings, prefix = _a.prefix;
    return (react_1.default.createElement("main", { className: className },
        prefix,
        strings && strings.length > 0 ? (react_1.default.createElement(react_typed_1.default, { strings: strings, typeSpeed: 80, backDelay: 2500, smartBackspace: false, loop: true })) : null));
};
exports.default = RotatingLinks;
